<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <app-form-control [underlineInputStyle]="true">
    <input
      [formControl]="form.controls.username"
      appPrimengInputText
      pInputText
      placeholder="Nazwa użytkownika" />
  </app-form-control>

  <app-form-control [underlineInputStyle]="true">
    <input
      [formControl]="form.controls.email"
      appPrimengInputText
      pInputText
      placeholder="Adres e-mail"
      type="email" />
  </app-form-control>

  <app-form-control [underlineInputStyle]="true">
    <div class="flex">
      <p-password
        [fluid]="true"
        [formControl]="form.controls.password"
        appPrimengPassword
        autocomplete="off"
        class="mr-3 flex-1"
        placeholder="Wprowadź hasło" />

      <p-button
        (onClick)="handleGeneratePasswordClick()"
        [text]="true"
        appPrimengButton
        label="Generuj hasło"
        type="button" />
    </div>
  </app-form-control>

  <app-form-control [underlineInputStyle]="true">
    <input
      [formControl]="form.controls.companyName"
      appPrimengInputText
      pInputText
      placeholder="Nazwa firmy" />
  </app-form-control>

  <app-form-control [underlineInputStyle]="true">
    <input
      [formControl]="form.controls.nip"
      appPrimengInputText
      pInputText
      placeholder="NIP" />
  </app-form-control>

  <app-form-control inputId="bcb634ee-bf24-4739-915c-1c333068100d">
    <app-checkbox-with-label inputId="bcb634ee-bf24-4739-915c-1c333068100d">
      <p-checkbox
        [binary]="true"
        [formControl]="form.controls.regulations" />

      <app-regulations-checkbox-label label />
    </app-checkbox-with-label>
  </app-form-control>

  <app-form-control inputId="281a5d1b-7e19-42c6-9084-155a149f1a04">
    <app-checkbox-with-label inputId="281a5d1b-7e19-42c6-9084-155a149f1a04">
      <p-checkbox
        [binary]="true"
        [formControl]="form.controls.newsletter" />

      <app-newsletter-checkbox-label label />
    </app-checkbox-with-label>
  </app-form-control>

  <app-privacy-policy-clause />

  <div class="flex justify-center">
    <app-form-control>
      <app-re-captcha [formControl]="form.controls.recaptcha" />
    </app-form-control>
  </div>

  <p-button
    [disabled]="form.invalid"
    [fluid]="true"
    appPrimengButton
    label="Zarejestruj"
    size="large"
    type="submit" />
</form>
